import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import CustomPropTypes from '../../util/custom-prop-types';
import { StyledParagraph } from './Paragraph.styles';

/**
 * A block level alias for the `Text`component and is equivalent to `<Text as="p" fontType="body">`.
 *
 * @extends Text
 * @related ['Heading']
 * @since 6.0.0
 */
export var Paragraph = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledParagraph, _extends({
    as: "p",
    fontType: "body",
    ref: forwardedRef
  }, props));
});
Paragraph.displayName = 'Paragraph';
Paragraph.propTypes = {
  /**
   * Change the text alignment of the paragraph.
   *
   * Supports inline media query objects.
   */
  textAlign: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['left', 'center', 'right'])),
  /**
   * Change the text wrapping of the paragraph.
   *
   * Note: This feature is a part of [CSS Text Level 4](https://www.w3.org/TR/css-text-4/#text-wrap)
   * and not yet supported across all browsers.
   *
   * Supports inline media query objects.
   */
  textWrap: CustomPropTypes.inlineMediaQuery(PropTypes.oneOf(['wrap', 'nowrap', 'balance', 'stable', 'pretty']))
};